export default "__VITE_ASSET__Dn9W6jfQ__"